export default {
    user: null,
    protocolsRD: null,
    protocolsTI: null,
    reports: null,
    events: null,
    expiredEvents: [],
    reportsUnsigned: null,
    protocol: null,
    exams: null,
    diagnosticHypothesis: null,
    outcomes: null,
    report: null,
    specialistsActives: null,
    enable: null,
    urlReport: null,
    urlFile: null,
    reportFields: null,
    tokenMemed: null,
    chatMessages: [],
    activeConversationId: null,
    isModalSignatureRequiredOpen: false,
    form: {
        error: null
    },
    version: '4.000',    
}